<editor
  [id]="id"
  [initialValue]="value"
  (onChange)="setValue($event.editor.getContent())"
  (onUndo)="setValue($event.editor.getContent())"
  (onRedo)="setValue($event.editor.getContent())"
  (onBlur)="onTouched()"
  [init]="config"
></editor>
